import { BroadcastMessageType, broadcastMessage } from '../lib/broadcastMessage'

const onClick = () =>
  broadcastMessage({ type: BroadcastMessageType.FrameClose, crossOrigin: true })

export function CreateProjectLink({ externalGroupName, createProjectUrl }) {
  if (externalGroupName && createProjectUrl) {
    return (
      <a
        href={createProjectUrl}
        rel="noopener"
        target="_blank"
        className="pds-weight-semi"
        onClick={onClick}
      >
        Create project “{externalGroupName}”
      </a>
    )
  }
  return null
}
